/**
 * @fileoverview gRPC-Web generated client stub for no.jotta.openapi.sharing.v2
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.22.5
// source: no/jotta/openapi/sharing/v2/sharing.v2.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('../../../../../google/api/annotations_pb.js')

var no_jotta_openapi_ping_pb = require('../../../../../no/jotta/openapi/ping_pb.js')

var no_jotta_openapi_file_file_v2_pb = require('../../../../../no/jotta/openapi/file/file.v2_pb.js')

var no_jotta_openapi_ref_pb = require('../../../../../no/jotta/openapi/ref_pb.js')

var no_jotta_openapi_avatar_pb = require('../../../../../no/jotta/openapi/avatar_pb.js')
const proto = {};
proto.no = {};
proto.no.jotta = {};
proto.no.jotta.openapi = {};
proto.no.jotta.openapi.sharing = {};
proto.no.jotta.openapi.sharing.v2 = require('./sharing.v2_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.sharing.v2.PublicSharingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.sharing.v2.PublicSharingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.LookupShareRequest,
 *   !proto.no.jotta.openapi.sharing.v2.LookupShareResponse>}
 */
const methodDescriptor_PublicSharingService_LookupShare = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.PublicSharingService/LookupShare',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.LookupShareRequest,
  proto.no.jotta.openapi.sharing.v2.LookupShareResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.LookupShareResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.LookupShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.LookupShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.PublicSharingServiceClient.prototype.lookupShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.PublicSharingService/LookupShare',
      request,
      metadata || {},
      methodDescriptor_PublicSharingService_LookupShare,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.LookupShareResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.PublicSharingServicePromiseClient.prototype.lookupShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.PublicSharingService/LookupShare',
      request,
      metadata || {},
      methodDescriptor_PublicSharingService_LookupShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.PingRequest,
 *   !proto.no.jotta.openapi.PingResponse>}
 */
const methodDescriptor_PublicSharingService_Ping = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.PublicSharingService/Ping',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_ping_pb.PingRequest,
  no_jotta_openapi_ping_pb.PingResponse,
  /**
   * @param {!proto.no.jotta.openapi.PingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_ping_pb.PingResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.PingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.PingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.PublicSharingServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.PublicSharingService/Ping',
      request,
      metadata || {},
      methodDescriptor_PublicSharingService_Ping,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.PingResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.PublicSharingServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.PublicSharingService/Ping',
      request,
      metadata || {},
      methodDescriptor_PublicSharingService_Ping);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.EnableShareRequest,
 *   !proto.no.jotta.openapi.sharing.v2.EnableShareResponse>}
 */
const methodDescriptor_SharingService_EnablePublicShare = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/EnablePublicShare',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.EnableShareRequest,
  proto.no.jotta.openapi.sharing.v2.EnableShareResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.EnableShareResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.EnableShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.EnableShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.enablePublicShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/EnablePublicShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_EnablePublicShare,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.EnableShareResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.enablePublicShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/EnablePublicShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_EnablePublicShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.DisableShareRequest,
 *   !proto.no.jotta.openapi.sharing.v2.DisableShareResponse>}
 */
const methodDescriptor_SharingService_DisablePublicShare = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/DisablePublicShare',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.DisableShareRequest,
  proto.no.jotta.openapi.sharing.v2.DisableShareResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.DisableShareResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.DisableShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.DisableShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.disablePublicShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/DisablePublicShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_DisablePublicShare,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.DisableShareResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.disablePublicShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/DisablePublicShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_DisablePublicShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest,
 *   !proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse>}
 */
const methodDescriptor_SharingService_GetShareInfo = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/GetShareInfo',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest,
  proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.getShareInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/GetShareInfo',
      request,
      metadata || {},
      methodDescriptor_SharingService_GetShareInfo,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.getShareInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/GetShareInfo',
      request,
      metadata || {},
      methodDescriptor_SharingService_GetShareInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.InviteMemberRequest,
 *   !proto.no.jotta.openapi.sharing.v2.InviteMemberResponse>}
 */
const methodDescriptor_SharingService_InviteMember = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/InviteMember',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.InviteMemberRequest,
  proto.no.jotta.openapi.sharing.v2.InviteMemberResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.InviteMemberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.inviteMember =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/InviteMember',
      request,
      metadata || {},
      methodDescriptor_SharingService_InviteMember,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.inviteMember =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/InviteMember',
      request,
      metadata || {},
      methodDescriptor_SharingService_InviteMember);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.JoinShareRequest,
 *   !proto.no.jotta.openapi.sharing.v2.JoinShareResponse>}
 */
const methodDescriptor_SharingService_JoinShare = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/JoinShare',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.JoinShareRequest,
  proto.no.jotta.openapi.sharing.v2.JoinShareResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.JoinShareResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.JoinShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.JoinShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.joinShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/JoinShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_JoinShare,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.JoinShareResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.joinShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/JoinShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_JoinShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.DeclineShareRequest,
 *   !proto.no.jotta.openapi.sharing.v2.DeclineShareResponse>}
 */
const methodDescriptor_SharingService_DeclineShare = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/DeclineShare',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.DeclineShareRequest,
  proto.no.jotta.openapi.sharing.v2.DeclineShareResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.DeclineShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.DeclineShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.declineShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/DeclineShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_DeclineShare,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.DeclineShareResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.declineShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/DeclineShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_DeclineShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.LeaveShareRequest,
 *   !proto.no.jotta.openapi.sharing.v2.LeaveShareResponse>}
 */
const methodDescriptor_SharingService_LeaveShare = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/LeaveShare',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.LeaveShareRequest,
  proto.no.jotta.openapi.sharing.v2.LeaveShareResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.LeaveShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.LeaveShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.leaveShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/LeaveShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_LeaveShare,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.LeaveShareResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.leaveShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/LeaveShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_LeaveShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest,
 *   !proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse>}
 */
const methodDescriptor_SharingService_RemoveMember = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/RemoveMember',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest,
  proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.removeMember =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/RemoveMember',
      request,
      metadata || {},
      methodDescriptor_SharingService_RemoveMember,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.removeMember =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/RemoveMember',
      request,
      metadata || {},
      methodDescriptor_SharingService_RemoveMember);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest,
 *   !proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse>}
 */
const methodDescriptor_SharingService_DisableFolderShare = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/DisableFolderShare',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest,
  proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.disableFolderShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/DisableFolderShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_DisableFolderShare,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.disableFolderShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/DisableFolderShare',
      request,
      metadata || {},
      methodDescriptor_SharingService_DisableFolderShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest,
 *   !proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse>}
 */
const methodDescriptor_SharingService_GetAddressBook = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/GetAddressBook',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest,
  proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.getAddressBook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/GetAddressBook',
      request,
      metadata || {},
      methodDescriptor_SharingService_GetAddressBook,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.getAddressBook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/GetAddressBook',
      request,
      metadata || {},
      methodDescriptor_SharingService_GetAddressBook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest,
 *   !proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse>}
 */
const methodDescriptor_SharingService_ListPendingInvites = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/ListPendingInvites',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest,
  proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.listPendingInvites =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/ListPendingInvites',
      request,
      metadata || {},
      methodDescriptor_SharingService_ListPendingInvites,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.listPendingInvites =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/ListPendingInvites',
      request,
      metadata || {},
      methodDescriptor_SharingService_ListPendingInvites);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest,
 *   !proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse>}
 */
const methodDescriptor_SharingService_ListFolderShares = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/ListFolderShares',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest,
  proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse,
  /**
   * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.listFolderShares =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/ListFolderShares',
      request,
      metadata || {},
      methodDescriptor_SharingService_ListFolderShares,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.listFolderShares =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/ListFolderShares',
      request,
      metadata || {},
      methodDescriptor_SharingService_ListFolderShares);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.PingRequest,
 *   !proto.no.jotta.openapi.PingResponse>}
 */
const methodDescriptor_SharingService_Ping = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.sharing.v2.SharingService/Ping',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_ping_pb.PingRequest,
  no_jotta_openapi_ping_pb.PingResponse,
  /**
   * @param {!proto.no.jotta.openapi.PingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_ping_pb.PingResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.PingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.PingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.sharing.v2.SharingServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/Ping',
      request,
      metadata || {},
      methodDescriptor_SharingService_Ping,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.PingResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.sharing.v2.SharingServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.sharing.v2.SharingService/Ping',
      request,
      metadata || {},
      methodDescriptor_SharingService_Ping);
};


module.exports = proto.no.jotta.openapi.sharing.v2;

